// @flow
import React from 'react'
import I18n from 'i18n-react'
import Collapse from 'reactstrap/lib/Collapse'
import Modal from 'reactstrap/lib/Modal'
import ModalBody from 'reactstrap/lib/ModalBody'

// components
import ErrorsDrawer from './ErrorsDrawer'
import ScrollLock from 'react-scrolllock'
import isMobile from 'is-mobile'

// types
import type { ValidationErrorsType } from '../../Types/ValidationError'

type ErrorsPanelProps = {
  debug: boolean,
  errors: ValidationErrorsType,
  isVisible?: boolean,
  onHide: () => void,
  showPrefixes?: boolean,
  texts: any,
}

type ErrorsPanelState = {
  bodyCollapsed: boolean,
}

export default class ErrorsPanel extends React.Component<ErrorsPanelProps, ErrorsPanelState> {
  static defaultProps = {
    errors: {},
    isVisible: true,
    onHide: () => null,
    showPrefixes: false,
  }

  state = {
    bodyCollapsed: true,
  }

  getNumberOfErrorsInObject = (errors: ValidationErrorsType, count: number) => {
    if (typeof errors === 'object' && !errors.error_type) {
      return Object.keys(errors).reduce((acc, errKey) => {
        if (typeof errors[errKey] === 'object' && !errors[errKey].error_type) {
          // $FlowFixMe
          acc += this.getNumberOfErrorsInObject(errors[errKey], count)
        } else {
          acc += 1
        }
        return acc
      }, count)
    } else if (errors.error_type) {
      return count + 1
    }
    return count
  }

  handleOnHide = () => {
    this.setState({ bodyCollapsed: true })
    this.props.onHide()
  }

  handleToggleBodyCollapsed = () => {
    this.setState({ bodyCollapsed: !this.state.bodyCollapsed })
  }

  render() {
    const { errors, isVisible, debug, texts } = this.props
    let errorCount = this.getNumberOfErrorsInObject(errors, 0)
    if (!isVisible || errorCount === 0) {
      return null
    }
    return (
      <Modal contentClassName='border-0' isOpen={isVisible} toggle={this.handleOnHide}>
        <ModalBody className='border-0 m-0 p-0'>
          <div className='alert alert-error mw-100 m-0' role='alert'>
            <div className='alert-header bg-primary'>
              <h5 className='alert-title' onClick={this.handleToggleBodyCollapsed}>
                {I18n.translate('validationErrors.errorsPanel.title')}
              </h5>
              <a className='close btn btn-link' onClick={this.handleOnHide}>
                <i className='pfp pfp-close'/>
              </a>
            </div>
            <Collapse className='alert-body' isOpen={this.state.bodyCollapsed}>
              <ErrorsDrawer
                debug={debug}
                errors={errors}
                labelValue=''
                prefix=''
                texts={texts}
              />
            </Collapse>
          </div>
        </ModalBody>
        {isVisible && isMobile() && <ScrollLock />}
      </Modal>
    )
  }
}
